export function packageIdentity(pkg) {
    return {
        item_id: pkg.uuid,
        item_name: pkg.name,
        item_category: "PACKAGE_PRODUCTS",
    };
}
export function templateProductIdentity(product, template) {
    var _a;
    const identity = {
        item_id: product.uuid,
        item_name: product.name,
        item_category: "TEMPLATE_PRODUCT",
        item_variant: template.name,
        item_variant_id: template.uuid,
    };
    ((_a = template.categories) !== null && _a !== void 0 ? _a : []).forEach((category, index) => {
        // +2, as item_category is the first
        identity[`item_category${index + 2}`] = category;
    });
    return identity;
}
